<template>
  <div>
    <Tour v-if="showTour" class="d-none d-xl-block" />
    <div class="file-manager-application">
      <div class="content-overlay" />
      <div class="header-navbar-shadow" />
      <div class="content-area-wrapper">
        <LeftSidebar />
        <div id="content-right" class="content-right">
          <div class="content-wrapper">
            <div class="content-header row" />
            <div class="content-body">
              <!-- overlay container -->
              <div class="body-content-overlay" />
              <RouterView />
            </div>
          </div>
        </div>
      </div>
      <NewEntityModal />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import LeftSidebar from '@/components/LeftSidebar.vue'
import NewEntityModal from './components/NewEntityModal'
import Tour from './components/Tour'

export default {
  components: {
    LeftSidebar,
    NewEntityModal,
    Tour
  },
  data: function() {
    return {}
  },
  computed: {
    ...mapState('home', ['contents']),
    ...mapState('auth', ['showTour'])
  },
  mounted: function() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.vault-label {
  margin-left: 15px;
}

@media screen and (min-width: 1200px) {
  .content-area-wrapper {
    height: calc(var(--vh, 1vh) * 100 - 8.5rem) !important;
  }
}
.content-body {
  @media (min-width: 1200px) {
    height: calc(100% - 0.5rem) !important;
  }

  // @media (min-width: 776px) and (max-width: 1200px) {
  //   height: calc(100% - 1rem) !important;
  // }

  // @media (min-width: 576px) and (max-width: 776px) {
  //   height: calc(100% - 1rem) !important;
  // }
}
</style>
